import React, { useMemo } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { isTrue } from "../../../../../../service/service";
import moment from "moment/moment";
import { isNull } from "lodash-es";

const states = [
    {
        label: "未开始",
        value: 0,
        className: style.state
    },
    {
        label: "进行中",
        value: 1,
        className: style.doing
    },
    {
        label: "已结束",
        value: 2,
        className: style.done
    }
];

interface Props {
    isStart: BooleanValue;
    deadline: string;
}
export default function ListStatus({ isStart, deadline }: Props) {
    const state = useMemo(() => {
        if (!isTrue(isStart)) {
            return 0;
        }
        if (isTrue(isStart) && moment(deadline).isAfter()) {
            return 1;
        }
        if (isTrue(isStart) && isNull(deadline)) {
            return 1;
        }
        if (isTrue(isStart) && moment(deadline).isBefore()) {
            return 2;
        }
    }, [isStart, deadline]);

    const itemData = useMemo(
        () => states.find(item => item.value === state),
        [state]
    );

    return (
        <div className={classNames(style.root, itemData?.className)}>
            {itemData?.label}
        </div>
    );
}
